import { render, staticRenderFns } from "./userDetails.vue?vue&type=template&id=4769aae2"
import script from "./userDetails.vue.ts?vue&type=script&lang=ts&external"
export * from "./userDetails.vue.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports